import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import useIsMobile from "@hooks/useIsMobile";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import DrawerSelect from "@/components/DrawerSelect/DrawerSelect";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import erp_cities_with_areas from "@data/lookups_language_customized/erp_cities_with_areas.json";
import { useSellCarData } from "@/common/Contexts/SellCarDataContext";
import { useLang } from "@/common/Contexts/LanguageContext";
import { DialogSelect } from "@/components/DialogSelect/DialogSelect";
import { Icon } from "@syarahtech/ui";
import useBoolean from "@hooks/useBoolean";
import { DrawerPortal } from "@/components/Drawer";
import { Drawer } from "vaul";
import LocationMapModal from "@/pages/sell-my-car/components/LocationMapModal";
import { Dialog, DialogContent } from "@/components/Dialog";
import { Autocomplete, useJsApiLoader } from "@react-google-maps/api";
import { GOOGLE_API_MAP_KEY } from "@globalConfig";
import { toast } from "sonner";
var libraries = ['places', 'geometry'];

// City coordinates mapping for initial map positioning
var cityCoordinates = {
  '1': {
    lat: 24.7136,
    lng: 46.6753
  },
  // Riyadh
  '2': {
    lat: 21.4858,
    lng: 39.1925
  },
  // Jeddah
  '3': {
    lat: 26.4207,
    lng: 50.0888
  },
  // Dammam
  '4': {
    lat: 21.3891,
    lng: 39.8579
  },
  // Makkah
  '5': {
    lat: 24.4539,
    lng: 39.6142
  },
  // Madinah
  '6': {
    lat: 26.3040,
    lng: 50.2131
  },
  // Al Khobar
  '7': {
    lat: 25.3960,
    lng: 49.9840
  },
  // Dhahran
  '8': {
    lat: 21.2854,
    lng: 40.4167
  },
  // Taif
  '9': {
    lat: 26.4324,
    lng: 50.1033
  },
  // Qatif
  '10': {
    lat: 18.2164,
    lng: 42.5053
  },
  // Abha
  '11': {
    lat: 28.3838,
    lng: 36.5550
  },
  // Tabuk
  '12': {
    lat: 27.5114,
    lng: 41.7208
  },
  // Hail
  '13': {
    lat: 29.9697,
    lng: 40.2064
  },
  // Sakaka
  '14': {
    lat: 17.4933,
    lng: 44.1277
  },
  // Najran
  '15': {
    lat: 16.8892,
    lng: 42.5611
  },
  // Jazan
  '16': {
    lat: 20.0125,
    lng: 41.4650
  },
  // Al Bahah
  '17': {
    lat: 25.8103,
    lng: 43.4839
  } // Qassim/Buraidah
};
var UserLocationInspection = function UserLocationInspection() {
  var _state$draftOrder8, _state$draftOrder8$cu, _state$draftOrder9, _state$draftOrder9$cu, _state$draftOrder9$cu2, _selectedLocation$det2, _state$draftOrder11, _state$draftOrder11$i, _state$draftOrder12, _state$draftOrder12$i, _selectedLocation$det3, _state$draftOrder13, _state$draftOrder13$i, _state$draftOrder13$i2, _state$draftOrder14, _state$draftOrder14$i, _state$draftOrder14$i2;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var isMobile = useIsMobile();
  var lang = useLang();
  var _useSellCarData = useSellCarData(),
    state = _useSellCarData.state,
    actions = _useSellCarData.actions;
  var _useState = useState(null),
    selectedArea = _useState[0],
    setSelectedArea = _useState[1];
  var locationModal = useBoolean();
  var autocompleteRef = useRef(null);
  var mapModalRef = useRef(null);
  var _useState2 = useState(false),
    isLoadingDetails = _useState2[0],
    setIsLoadingDetails = _useState2[1];
  var _useState3 = useState(false),
    hasValidMapLocation = _useState3[0],
    setHasValidMapLocation = _useState3[1];
  var _useJsApiLoader = useJsApiLoader({
      googleMapsApiKey: GOOGLE_API_MAP_KEY,
      libraries: libraries
    }),
    isJSAPILoaded = _useJsApiLoader.isLoaded;

  // Get initial coordinates based on city or default to Riyadh
  var getInitialCoordinates = function getInitialCoordinates() {
    var _state$draftOrder, _state$draftOrder$cur, _state$draftOrder$cur2;
    var cityIdFromData = state === null || state === void 0 ? void 0 : (_state$draftOrder = state.draftOrder) === null || _state$draftOrder === void 0 ? void 0 : (_state$draftOrder$cur = _state$draftOrder.currentStep) === null || _state$draftOrder$cur === void 0 ? void 0 : (_state$draftOrder$cur2 = _state$draftOrder$cur.data) === null || _state$draftOrder$cur2 === void 0 ? void 0 : _state$draftOrder$cur2.city_id;
    if (cityIdFromData && cityCoordinates[cityIdFromData]) {
      return cityCoordinates[cityIdFromData];
    }
    return {
      lat: 24.7136,
      lng: 46.6753
    }; // Default to Riyadh
  };
  var _useState4 = useState(function () {
      var initialCoords = getInitialCoordinates();
      return {
        lat: initialCoords.lat,
        lng: initialCoords.lng,
        details: null
      };
    }),
    selectedLocation = _useState4[0],
    setSelectedLocation = _useState4[1];
  useEffect(function () {
    var _state$draftOrder2, _state$draftOrder3, _state$draftOrder3$cu, _state$draftOrder3$cu2;
    // Check if there's user-entered customer location data in inspectionLocation
    var inspectionData = state === null || state === void 0 ? void 0 : (_state$draftOrder2 = state.draftOrder) === null || _state$draftOrder2 === void 0 ? void 0 : _state$draftOrder2.inspectionLocation;
    if (inspectionData !== null && inspectionData !== void 0 && inspectionData.areaId || inspectionData !== null && inspectionData !== void 0 && inspectionData.latitude) {
      // Restore from user-entered data (check for fields, not type)
      if (inspectionData.areaId) {
        var areaFromInspection = areas.find(function (area) {
          return area.id === inspectionData.areaId;
        });
        if (areaFromInspection) {
          setSelectedArea(areaFromInspection);
        }
      }
      if (inspectionData.latitude && inspectionData.longitude) {
        setSelectedLocation({
          lat: +inspectionData.latitude,
          lng: +inspectionData.longitude,
          details: inspectionData.locationDetails || {
            formatted_address: null
          }
        });
      }
    } else if (state !== null && state !== void 0 && (_state$draftOrder3 = state.draftOrder) !== null && _state$draftOrder3 !== void 0 && (_state$draftOrder3$cu = _state$draftOrder3.currentStep) !== null && _state$draftOrder3$cu !== void 0 && (_state$draftOrder3$cu2 = _state$draftOrder3$cu.data) !== null && _state$draftOrder3$cu2 !== void 0 && _state$draftOrder3$cu2.area_id) {
      var _state$draftOrder5, _state$draftOrder5$cu, _state$draftOrder5$cu2, _state$draftOrder6, _state$draftOrder6$cu, _state$draftOrder6$cu2, _state$draftOrder7, _state$draftOrder7$cu, _state$draftOrder7$cu2;
      // Fall back to API data
      var areaFromApi = areas.find(function (area) {
        var _state$draftOrder4, _state$draftOrder4$cu, _state$draftOrder4$cu2;
        return area.id === (state === null || state === void 0 ? void 0 : (_state$draftOrder4 = state.draftOrder) === null || _state$draftOrder4 === void 0 ? void 0 : (_state$draftOrder4$cu = _state$draftOrder4.currentStep) === null || _state$draftOrder4$cu === void 0 ? void 0 : (_state$draftOrder4$cu2 = _state$draftOrder4$cu.data) === null || _state$draftOrder4$cu2 === void 0 ? void 0 : _state$draftOrder4$cu2.area_id);
      });
      setSelectedArea(areaFromApi);
      setSelectedLocation({
        lat: +(state === null || state === void 0 ? void 0 : (_state$draftOrder5 = state.draftOrder) === null || _state$draftOrder5 === void 0 ? void 0 : (_state$draftOrder5$cu = _state$draftOrder5.currentStep) === null || _state$draftOrder5$cu === void 0 ? void 0 : (_state$draftOrder5$cu2 = _state$draftOrder5$cu.data) === null || _state$draftOrder5$cu2 === void 0 ? void 0 : _state$draftOrder5$cu2.latitude),
        lng: +(state === null || state === void 0 ? void 0 : (_state$draftOrder6 = state.draftOrder) === null || _state$draftOrder6 === void 0 ? void 0 : (_state$draftOrder6$cu = _state$draftOrder6.currentStep) === null || _state$draftOrder6$cu === void 0 ? void 0 : (_state$draftOrder6$cu2 = _state$draftOrder6$cu.data) === null || _state$draftOrder6$cu2 === void 0 ? void 0 : _state$draftOrder6$cu2.longitude),
        details: {
          formatted_address: state === null || state === void 0 ? void 0 : (_state$draftOrder7 = state.draftOrder) === null || _state$draftOrder7 === void 0 ? void 0 : (_state$draftOrder7$cu = _state$draftOrder7.currentStep) === null || _state$draftOrder7$cu === void 0 ? void 0 : (_state$draftOrder7$cu2 = _state$draftOrder7$cu.data) === null || _state$draftOrder7$cu2 === void 0 ? void 0 : _state$draftOrder7$cu2.location
        }
      });
    }
    return function () {
      setSelectedArea(null);
      setSelectedLocation({
        lat: null,
        lng: null,
        details: null
      });
      actions.setInspectionLocation(null);
    };
  }, [state === null || state === void 0 ? void 0 : (_state$draftOrder8 = state.draftOrder) === null || _state$draftOrder8 === void 0 ? void 0 : (_state$draftOrder8$cu = _state$draftOrder8.currentStep) === null || _state$draftOrder8$cu === void 0 ? void 0 : _state$draftOrder8$cu.data]);

  // Get city_id from contact info in draft order
  //@TODO: this should be changed to city id
  var cityId = state === null || state === void 0 ? void 0 : (_state$draftOrder9 = state.draftOrder) === null || _state$draftOrder9 === void 0 ? void 0 : (_state$draftOrder9$cu = _state$draftOrder9.currentStep) === null || _state$draftOrder9$cu === void 0 ? void 0 : (_state$draftOrder9$cu2 = _state$draftOrder9$cu.data) === null || _state$draftOrder9$cu2 === void 0 ? void 0 : _state$draftOrder9$cu2.city_id;

  // Filter areas based on the selected city
  var areas = useMemo(function () {
    if (!cityId) return [];
    var languageData = lang === "ar" ? erp_cities_with_areas.ar : erp_cities_with_areas.en;
    var selectedCity = languageData.find(function (city) {
      return city.id === cityId;
    });
    return (selectedCity === null || selectedCity === void 0 ? void 0 : selectedCity.areas) || [];
  }, [cityId, lang]);

  // Search function for filtering areas in both English and Arabic
  var searchAreas = useCallback(function (items, searchTerm) {
    var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;
    if (!searchTerm || searchTerm.trim() === "") {
      return items.slice(0, limit);
    }
    var normalizedSearch = searchTerm.toLowerCase().trim();
    var results = items.filter(function (area) {
      var _area$name_en, _area$name_ar;
      return ((_area$name_en = area.name_en) === null || _area$name_en === void 0 ? void 0 : _area$name_en.toLowerCase().includes(normalizedSearch)) || ((_area$name_ar = area.name_ar) === null || _area$name_ar === void 0 ? void 0 : _area$name_ar.toLowerCase().includes(normalizedSearch));
    });
    return limit ? results.slice(0, limit) : results;
  }, []);

  // Get display name based on current language
  var getAreaDisplayName = useCallback(function (area) {
    return lang === "ar" ? area.name_ar : area.name_en;
  }, [lang]);

  // Geocode area name to get coordinates and center map
  var geocodeAreaAndCenterMap = useCallback(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(areaName, cityName) {
      var geocoder, searchQuery, response, location, lat, lng, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (!(!window.google || !window.google.maps || !areaName)) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            _context.p = 1;
            geocoder = new window.google.maps.Geocoder(); // Construct a search query with area name and city for better accuracy
            searchQuery = cityName ? "".concat(areaName, ", ").concat(cityName, ", Saudi Arabia") : "".concat(areaName, ", Saudi Arabia");
            _context.n = 2;
            return new Promise(function (resolve, reject) {
              geocoder.geocode({
                address: searchQuery,
                region: 'SA'
              }, function (results, status) {
                if (status === 'OK') {
                  resolve({
                    results: results || []
                  });
                } else {
                  reject(new Error("Geocoding failed: ".concat(status)));
                }
              });
            });
          case 2:
            response = _context.v;
            if (response.results && response.results.length > 0) {
              location = response.results[0].geometry.location;
              lat = location.lat();
              lng = location.lng(); // Pan the map to the area if modal is open
              if (mapModalRef.current && locationModal.value) {
                mapModalRef.current.panTo(lat, lng);
              }

              // Update selected location with new coordinates (but don't set details yet)
              setSelectedLocation(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                  lat: lat,
                  lng: lng
                });
              });
            }
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            console.error('Area geocoding error:', _t);
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), [locationModal.value]);
  var handleAreaChange = function handleAreaChange(area) {
    var _state$draftOrder0;
    setSelectedArea(area);

    // Update inspection location in context with area data
    var currentInspectionData = (state === null || state === void 0 ? void 0 : (_state$draftOrder0 = state.draftOrder) === null || _state$draftOrder0 === void 0 ? void 0 : _state$draftOrder0.inspectionLocation) || {};
    actions.setInspectionLocation(_objectSpread(_objectSpread({}, currentInspectionData), {}, {
      type: "customer_location",
      areaId: area === null || area === void 0 ? void 0 : area.id,
      areaName: lang === "ar" ? area === null || area === void 0 ? void 0 : area.name_ar : area === null || area === void 0 ? void 0 : area.name_en
    }));

    // Geocode the area and center map
    if (area && isJSAPILoaded) {
      var _state$draftOrder1, _state$draftOrder1$cu, _state$draftOrder1$cu2;
      var areaName = lang === "ar" ? area.name_ar : area.name_en;
      var cityName = state === null || state === void 0 ? void 0 : (_state$draftOrder1 = state.draftOrder) === null || _state$draftOrder1 === void 0 ? void 0 : (_state$draftOrder1$cu = _state$draftOrder1.currentStep) === null || _state$draftOrder1$cu === void 0 ? void 0 : (_state$draftOrder1$cu2 = _state$draftOrder1$cu.data) === null || _state$draftOrder1$cu2 === void 0 ? void 0 : _state$draftOrder1$cu2.city_name;
      geocodeAreaAndCenterMap(areaName, cityName);
    }
  };
  var handleLocationSelect = function handleLocationSelect(location) {
    var _state$draftOrder10;
    setSelectedLocation(location);
    locationModal.setFalse();

    // Update inspection location in context with location data
    var currentInspectionData = (state === null || state === void 0 ? void 0 : (_state$draftOrder10 = state.draftOrder) === null || _state$draftOrder10 === void 0 ? void 0 : _state$draftOrder10.inspectionLocation) || {};
    actions.setInspectionLocation(_objectSpread(_objectSpread({}, currentInspectionData), {}, {
      type: "customer_location",
      latitude: location.lat.toString(),
      longitude: location.lng.toString(),
      mapLink: "https://www.google.com/maps?q=".concat(location.lat, ",").concat(location.lng, "&z=15"),
      locationDetails: location.details
    }));
  };
  var handleOpenLocationModal = function handleOpenLocationModal() {
    var _selectedLocation$det;
    // Scroll to top to fix pac-container positioning issues on desktop
    if (!isMobile) {
      window.scrollTo({
        top: 0,
        behavior: 'instant'
      });
    }
    // If we already have a valid location with details, enable the button
    setHasValidMapLocation(!!(selectedLocation !== null && selectedLocation !== void 0 && (_selectedLocation$det = selectedLocation.details) !== null && _selectedLocation$det !== void 0 && _selectedLocation$det.formatted_address));
    locationModal.setTrue();
  };
  var handleLocationDenied = function handleLocationDenied(denied) {
    if (denied) {
      toast.error(tShort("location_permission_denied_message", {
        ns: "web_sell_trade"
      }), {
        position: "top-center",
        closeButton: true,
        duration: 5000
      });
    }
  };
  var onAutocompleteLoad = function onAutocompleteLoad(autocomplete) {
    autocompleteRef.current = autocomplete;
  };
  var onPlaceChanged = function onPlaceChanged() {
    if (autocompleteRef.current !== null) {
      var place = autocompleteRef.current.getPlace();
      if (place.geometry && place.geometry.location) {
        var _mapModalRef$current;
        var lat = place.geometry.location.lat();
        var lng = place.geometry.location.lng();

        // Extract address details from the place
        var components = place.address_components;
        var country = '';
        var city = '';
        var neighbourhood = '';
        var street = '';
        components === null || components === void 0 ? void 0 : components.forEach(function (component) {
          var types = component.types;
          if (types.includes('country')) {
            country = component.long_name;
          } else if (types.includes('administrative_area_level_1') || types.includes('locality')) {
            city = component.long_name;
          } else if (types.includes('sublocality') || types.includes('neighborhood')) {
            neighbourhood = component.long_name;
          } else if (types.includes('route')) {
            street = component.long_name;
          }
        });
        var locationDetails = {
          country: country,
          city: city,
          neighbourhood: neighbourhood,
          street: street,
          formatted_address: place.formatted_address || ''
        };

        // Update selected location with new coordinates and details
        var newLocation = {
          lat: lat,
          lng: lng,
          details: locationDetails
        };
        setSelectedLocation(newLocation);

        // Update the map modal with the new location details
        (_mapModalRef$current = mapModalRef.current) === null || _mapModalRef$current === void 0 ? void 0 : _mapModalRef$current.panTo(lat, lng, locationDetails);

        // Enable the confirm button when a valid place is selected
        setHasValidMapLocation(true);
      }
    }
  };
  var reverseGeocode = useCallback(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(lat, lng) {
      var geocoder, response, result, components, country, city, neighbourhood, street, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            if (!(!window.google || !window.google.maps)) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2, null);
          case 1:
            _context2.p = 1;
            geocoder = new window.google.maps.Geocoder();
            _context2.n = 2;
            return new Promise(function (resolve, reject) {
              geocoder.geocode({
                location: {
                  lat: lat,
                  lng: lng
                },
                language: 'ar'
              }, function (results, status) {
                if (status === 'OK') {
                  resolve({
                    results: results || []
                  });
                } else {
                  reject(new Error("Geocoding failed: ".concat(status)));
                }
              });
            });
          case 2:
            response = _context2.v;
            if (!(response.results && response.results.length > 0)) {
              _context2.n = 3;
              break;
            }
            result = response.results[0];
            components = result.address_components;
            country = '';
            city = '';
            neighbourhood = '';
            street = '';
            components === null || components === void 0 ? void 0 : components.forEach(function (component) {
              var types = component.types;
              if (types.includes('country')) {
                country = component.long_name;
              } else if (types.includes('administrative_area_level_1') || types.includes('locality')) {
                city = component.long_name;
              } else if (types.includes('sublocality') || types.includes('neighborhood')) {
                neighbourhood = component.long_name;
              } else if (types.includes('route')) {
                street = component.long_name;
              }
            });
            return _context2.a(2, {
              country: country,
              city: city,
              neighbourhood: neighbourhood,
              street: street,
              formatted_address: result.formatted_address
            });
          case 3:
            _context2.n = 5;
            break;
          case 4:
            _context2.p = 4;
            _t2 = _context2.v;
            console.error('Reverse geocoding error:', _t2);
          case 5:
            return _context2.a(2, null);
        }
      }, _callee2, null, [[1, 4]]);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }(), []);
  var updateLocationWithDetails = useCallback(/*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(lat, lng) {
      var details, newLocation;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            setIsLoadingDetails(true);
            _context3.n = 1;
            return reverseGeocode(lat, lng);
          case 1:
            details = _context3.v;
            newLocation = {
              lat: lat,
              lng: lng,
              details: details
            };
            setSelectedLocation(newLocation);
            setIsLoadingDetails(false);
          case 2:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }(), [reverseGeocode]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 pt-4 border-t border-gray-echo"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "font-bold text-xs leading-4 text-gray-text"
  }, tShort("sell_trade_v2/user_location_neighbour_label", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement(Conditional, {
    condition: isMobile
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(DrawerSelect, {
    value: selectedArea,
    onChange: handleAreaChange,
    options: areas,
    searchFunction: searchAreas,
    getDisplayName: getAreaDisplayName,
    placeholder: tShort("sell_trade_v2/select_area_placeholder", {
      ns: "web_sell_trade"
    }),
    searchPlaceholder: tShort("sell_trade_v2/search_area_placeholder", {
      ns: "web_sell_trade"
    }),
    drawerTitle: tShort("sell_trade_v2/select_area_title", {
      ns: "web_sell_trade"
    }),
    allowClear: false,
    limit: 50
  })), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(DialogSelect, {
    value: selectedArea,
    onChange: handleAreaChange,
    options: areas,
    searchFunction: searchAreas,
    getDisplayName: getAreaDisplayName,
    placeholder: tShort("sell_trade_v2/select_area_placeholder", {
      ns: "web_sell_trade"
    }),
    searchPlaceholder: tShort("sell_trade_v2/search_area_placeholder", {
      ns: "web_sell_trade"
    }),
    dialogTitle: tShort("sell_trade_v2/select_area_title", {
      ns: "web_sell_trade"
    }),
    allowClear: false,
    limit: 50
  })))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "font-bold text-xs leading-4 text-gray-text"
  }, tShort("sell_trade_v2/user_location_label", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement(Conditional, {
    condition: !!(selectedLocation !== null && selectedLocation !== void 0 && (_selectedLocation$det2 = selectedLocation.details) !== null && _selectedLocation$det2 !== void 0 && _selectedLocation$det2.formatted_address) || (state === null || state === void 0 ? void 0 : (_state$draftOrder11 = state.draftOrder) === null || _state$draftOrder11 === void 0 ? void 0 : (_state$draftOrder11$i = _state$draftOrder11.inspectionLocation) === null || _state$draftOrder11$i === void 0 ? void 0 : _state$draftOrder11$i.latitude) || (state === null || state === void 0 ? void 0 : (_state$draftOrder12 = state.draftOrder) === null || _state$draftOrder12 === void 0 ? void 0 : (_state$draftOrder12$i = _state$draftOrder12.inspectionLocation) === null || _state$draftOrder12$i === void 0 ? void 0 : _state$draftOrder12$i.longitude)
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement("div", {
    className: "relative cursor-pointer border border-solid border-gray-echo rounded-lg p-3 flex items-center gap-2 justify-between",
    onClick: handleOpenLocationModal
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-start gap-2 max-w-[90%]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-1 text-sm text-gray-text"
  }, /*#__PURE__*/React.createElement("p", {
    className: "line-clamp-1 overflow-hidden text-ellipsis"
  }, (selectedLocation === null || selectedLocation === void 0 ? void 0 : (_selectedLocation$det3 = selectedLocation.details) === null || _selectedLocation$det3 === void 0 ? void 0 : _selectedLocation$det3.formatted_address) || "".concat(state === null || state === void 0 ? void 0 : (_state$draftOrder13 = state.draftOrder) === null || _state$draftOrder13 === void 0 ? void 0 : (_state$draftOrder13$i = _state$draftOrder13.inspectionLocation) === null || _state$draftOrder13$i === void 0 ? void 0 : (_state$draftOrder13$i2 = _state$draftOrder13$i.latitude) === null || _state$draftOrder13$i2 === void 0 ? void 0 : _state$draftOrder13$i2.slice(0, 4), ", ").concat(state === null || state === void 0 ? void 0 : (_state$draftOrder14 = state.draftOrder) === null || _state$draftOrder14 === void 0 ? void 0 : (_state$draftOrder14$i = _state$draftOrder14.inspectionLocation) === null || _state$draftOrder14$i === void 0 ? void 0 : (_state$draftOrder14$i2 = _state$draftOrder14$i.longitude) === null || _state$draftOrder14$i2 === void 0 ? void 0 : _state$draftOrder14$i2.slice(0, 4))))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-1 p-1 rounded shadow-[0px_0px_4px_0px_rgba(0,0,0,0.10)] outline outline-[0.30px] outline-offset-[-0.30px] outline-blue-800/20  justify-center overflow-hidden"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--edit-outline-rounded",
    width: 4,
    height: 4,
    className: "text-primary-new"
  })))), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement("div", {
    className: "w-full border-2 border-solid p-1 rounded-lg border-gray-echo cursor-pointer hover:bg-gray-50 transition-colors flex justify-between items-center",
    onClick: handleOpenLocationModal
  }, /*#__PURE__*/React.createElement("p", {
    className: "font-medium text-xs text-black-primary"
  }, tShort("sell_trade_v2/choose_location_label", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("div", {
    className: "px-2.5 py-2 flex items-center gap-1 bg-[#E7E7F8] rounded-lg"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--add-2-rounded",
    width: 6,
    height: 6,
    className: "text-[#0D0DB5]"
  }), /*#__PURE__*/React.createElement("p", {
    className: "font-semibold text-xs text-[#0D0DB5]"
  }, tShort("sell_trade_v2/choose_location_map", {
    ns: "web_sell_trade"
  })))))))), /*#__PURE__*/React.createElement(Conditional, {
    condition: isMobile
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(Drawer.Root, {
    open: locationModal.value,
    onOpenChange: locationModal.setFalse,
    onClose: locationModal.setFalse,
    snapPoints: [1],
    dismissible: false,
    modal: false,
    repositionInputs: false
  }, /*#__PURE__*/React.createElement(DrawerPortal, null, /*#__PURE__*/React.createElement(Drawer.Content, {
    className: "bg-white flex flex-col rounded-t-[10px] h-full after:!h-fit mt-24 fixed bottom-0 left-0 right-0 z-[9999]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0 p-3 pt-4 border-b"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-base font-bold text-primary-new"
  }, tShort("sell_trade_v2/location_modal_title", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("div", {
    onClick: locationModal.setFalse,
    className: "bg-white border-0 outline-0",
    role: "button"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-small-rounded",
    width: 7,
    height: 7,
    className: "text-primary-new"
  })))), isJSAPILoaded && /*#__PURE__*/React.createElement("div", {
    className: "absolute top-[85px] w-[90%] bg-white h-3 rounded-lg z-[999999] left-[50%] transform translate-x-[-50%]"
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    onLoad: onAutocompleteLoad,
    onPlaceChanged: onPlaceChanged,
    options: {
      componentRestrictions: {
        country: 'SA'
      },
      fields: ['geometry', 'name', 'formatted_address', 'address_components']
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full relative"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    id: "search-location-desktop",
    autoComplete: "off",
    autoFocus: false,
    placeholder: tShort("location_modal_search_placeholder", {
      ns: "web_sell_trade"
    }),
    className: "w-full pe-10 ps-3 en:pl-10 en:text-left en:pr-4 py-3 border-none rounded-lg outline-none transition-all duration-200 placeholder:text-black-primary  hover:border-primary-new text-start placeholder:text-sm !text-base text-primary-new",
    onFocus: function onFocus() {},
    onChange: function onChange() {}
  }), /*#__PURE__*/React.createElement("div", {
    className: "w-fit absolute left-4 top-[50%] transform translate-y-[-40%]"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "text-primary-new",
    width: 6,
    height: 6,
    icon: "mingcute--search-2-line"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "flex-1 overflow-hidden flex flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-1"
  }, /*#__PURE__*/React.createElement(LocationMapModal, {
    ref: mapModalRef,
    initialCenter: selectedLocation.lat && selectedLocation.lng ? {
      lat: selectedLocation.lat,
      lng: selectedLocation.lng
    } : {
      lat: 24.7136,
      lng: 46.6753
    },
    onConfirm: handleLocationSelect,
    onLocationChange: setHasValidMapLocation,
    onLocationDenied: handleLocationDenied
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0 p-4 bg-white border-t border-gray-echo"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      if (mapModalRef.current) {
        var currentLocation = mapModalRef.current.getCurrentLocation();
        handleLocationSelect(currentLocation);
      }
    },
    disabled: isLoadingDetails || !hasValidMapLocation,
    className: "w-full px-6 py-3 bg-primary text-white font-bold rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed !border-none outline-0"
  }, isLoadingDetails ? /*#__PURE__*/React.createElement("span", {
    className: "flex items-center justify-center gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"
  }), tShort("loading", {
    ns: "web_sell_trade"
  })) : tShort("sell_trade_v2/confirm_location_button", {
    ns: "web_sell_trade"
  })))))))), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(Dialog, {
    open: locationModal.value,
    onOpenChange: locationModal.setFalse
  }, /*#__PURE__*/React.createElement(DialogContent, {
    className: "max-w-4xl max-h-[90vh] w-[70%] h-[70%] flex flex-col p-0 gap-0",
    haveClose: false,
    onPointerDownOutside: function onPointerDownOutside(e) {
      var _target$closest;
      // Prevent closing when clicking on Google Places Autocomplete dropdown
      var target = e.target;
      if (target !== null && target !== void 0 && (_target$closest = target.closest) !== null && _target$closest !== void 0 && _target$closest.call(target, '.pac-container')) {
        e.preventDefault();
      }
    },
    onInteractOutside: function onInteractOutside(e) {
      var _target$closest2;
      // Also handle interact outside for Google Places Autocomplete
      var target = e.target;
      if (target !== null && target !== void 0 && (_target$closest2 = target.closest) !== null && _target$closest2 !== void 0 && _target$closest2.call(target, '.pac-container')) {
        e.preventDefault();
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0 p-4 border-b"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-base font-bold text-primary-new"
  }, tShort("sell_trade_v2/location_modal_title", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("div", {
    onClick: locationModal.setFalse,
    className: "bg-white border-0 outline-0",
    role: "button"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "material-symbols--close-small-rounded",
    width: 7,
    height: 7,
    className: "text-primary-new"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "overflow-hidden w-full h-full flex flex-col relative"
  }, isJSAPILoaded && /*#__PURE__*/React.createElement("div", {
    className: "absolute top-4 w-[90%] bg-white rounded-lg z-[999999] left-[50%] transform translate-x-[-50%]"
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    onLoad: onAutocompleteLoad,
    onPlaceChanged: onPlaceChanged,
    options: {
      componentRestrictions: {
        country: 'SA'
      },
      fields: ['geometry', 'name', 'formatted_address', 'address_components']
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full relative"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    id: "search-location-desktop",
    autoComplete: "off",
    autoFocus: false,
    placeholder: tShort("location_modal_search_placeholder", {
      ns: "web_sell_trade"
    }),
    className: "w-full pe-10 ps-3 en:pl-10 en:text-left en:pr-4 py-3 border-none rounded-lg outline-none transition-all duration-200 placeholder:text-black-primary  hover:border-primary-new text-start placeholder:text-sm !text-base text-primary-new",
    onFocus: function onFocus() {},
    onChange: function onChange() {}
  }), /*#__PURE__*/React.createElement("div", {
    className: "w-fit absolute left-4 top-[50%] transform translate-y-[-40%]"
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "text-primary-new",
    width: 6,
    height: 6,
    icon: "mingcute--search-2-line"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "flex-1"
  }, /*#__PURE__*/React.createElement(LocationMapModal, {
    ref: mapModalRef,
    initialCenter: selectedLocation.lat && selectedLocation.lng ? {
      lat: selectedLocation.lat,
      lng: selectedLocation.lng
    } : {
      lat: 24.7136,
      lng: 46.6753
    },
    onConfirm: handleLocationSelect,
    onLocationChange: setHasValidMapLocation,
    onLocationDenied: handleLocationDenied
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex-shrink-0 p-4 bg-white border-t border-gray-echo"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      if (mapModalRef.current) {
        var currentLocation = mapModalRef.current.getCurrentLocation();
        handleLocationSelect(currentLocation);
      }
    },
    disabled: isLoadingDetails || !hasValidMapLocation,
    className: "w-full px-6 py-3 bg-primary text-white font-bold rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed border-none"
  }, isLoadingDetails ? /*#__PURE__*/React.createElement("span", {
    className: "flex items-center justify-center gap-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"
  }), tShort("loading", {
    ns: "web_sell_trade"
  })) : tShort("sell_trade_v2/confirm_location_button", {
    ns: "web_sell_trade"
  })))))))));
};
export default UserLocationInspection;